(function($, $window, $document) {
    'use strict';

    var finding                 = false,
        $eventsDatepicker       = $('.events-datepicker'),
        $eventsHolderList		= $('#searched_events_list'),
        $searchedEventsHolder 	= $('#searched_events_holder'),
        $defaultEventsHolder 	= $('#default_events_holder'),
        $tabsHolder				= $('#event_categories_tabs'),

        $searchEventsErrorMessage = $('#searched_events_error_message'),

        templateId 				= $eventsDatepicker.attr('data-template-id'),
        eventsTemplateEl 		= $('#' + templateId)[0],
        defaultSearchParams		= parseJson($eventsDatepicker.attr('data-search-params')),
        selectedDate 			= $eventsDatepicker.attr('data-selected-date'),

        $genericTitleHolder     = $('.events_holder .search_generic_title'),
        $loaderHolder           = $('.events_holder #loading-sp'),

        $resetSearchBtn         = $('#search_events_reset');

    $eventsDatepicker.datepicker({
        showOtherMonths: true,
        selectOtherMonths: true,
        defaultDate: selectedDate,
        onSelect: function(dateText, inst) {
          	datepickerDateChanged(new Date(inst.selectedYear, inst.selectedMonth + 1, inst.selectedDay))
        },
        beforeShowDay: function (date) {
          	date = addLeadingZero(date.getMonth() + 1) + '/' + addLeadingZero(date.getDate()) + '/' +  date.getFullYear();

          	return [selectedDates.indexOf(date) > -1, selectedDates.indexOf(date) > -1 ? 'has_events' : '']
        }
    });

    $resetSearchBtn.on('click', function () {
        $resetSearchBtn.hide();
        $searchedEventsHolder.hide();
        $genericTitleHolder.html('');
        $defaultEventsHolder.show();
        $loaderHolder.hide();
        
        
        // searchForEventsOnDate().then(function () {
        // });
    })

    function datepickerDateChanged(date) {
    	searchForEventsOnDate(date).then(function () {
            $resetSearchBtn.show();
        });
    }

    function searchForEventsOnDate(date) {
        if (finding) {
            return
        }

        finding = true
        eventsLoading();

  		var params = Object.assign({}, defaultSearchParams, {
  			date_from: formatDateForRequest(date)
  		})

        return $.getJSON(
        	rest_api.endpoints.events,
        	params
        )
        .done(function (response) {
        	setEventCategoriesNumbers(response.event_cats);
            showGenericTitle(response.title);
        	showEventsOnList(response.events);
            scrollToEventsList();
        })
        .always(function () {
            finding = false
            eventsLoaded();
        })
    }

    function formatDateForRequest(date) {
        if (! date) {
            return;
        }

    	return addLeadingZero(date.getMonth()) + '/' + addLeadingZero(date.getDate()) + '/' +  date.getFullYear();
    }

    function showEventsOnList(events) {
    	var html = '';
    	
    	clearEventsList();

        events.forEach(function (event) {
            html += makeHtmlStringElementForEvent(event);
        })
        
        if (events.length > 0) {
            $searchEventsErrorMessage.hide();
        } else {
            $searchEventsErrorMessage.show();
        }

    	$searchedEventsHolder.show();
    	$defaultEventsHolder.hide();
    	$eventsHolderList.html(html);
    }

    function showGenericTitle(title) {
        $genericTitleHolder.html(title).show();
    }

    function scrollToEventsList() {
        $('html, body').animate({
            scrollTop: $eventsHolderList.offset().top - ($('header').outerHeight(true) + 60)
        }, 600);
    }

    function setEventCategoriesNumbers(event_cats) {
    	Object.keys(event_cats).forEach(function (cat_id) {
            var $item = $tabsHolder.find('li a[data-catid="' + cat_id + '"]');

    		$item.find('.number_holder').text(event_cats[cat_id].count)

            $item.attr('href', event_cats[cat_id].link)
            
            if(event_cats[cat_id].count == 0){
                $item.addClass('hidden');
            }else{
        		$item.removeClass('hidden');
            }            
    	})
    }

    function makeHtmlStringElementForEvent(event) {
    	var template = eventsTemplateEl.innerHTML;

    	Object.keys(event).forEach(function (key) {
    		template = template.replace('{% ' + key + ' %}', event[key]);
    	})

    	return template
    }

    function eventsLoading() {
        $loaderHolder.show();
        $genericTitleHolder.hide();
    }

    function eventsLoaded() {
        $loaderHolder.hide();
        $genericTitleHolder.show();
    }

    function clearEventsList() {
    	$eventsHolderList.html('');
    }

    function addLeadingZero(nr) {
        return nr < 10 ? '0' + nr : nr;
    }

    function parseJson(jsonString) {
    	try {
    		return JSON.parse(jsonString)
    	} catch (e) {
    		return {};
    	}
    }
})(window.jQuery, window, document);
